import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { useDirect, useTheme } from "../hooks";
import { CustomToast, Theme } from "../component";
import router from "./router";
import { useEffect } from "react";
import keyNames from "../keyName";
import { useSelector } from "react-redux";

const Layout = () => {
  const themes = useTheme();
  const directDispatch = useDirect();
  const storeData = useSelector((state) => state.mainReducer);
  const { forceLogOut } = storeData;
  useEffect(() => {
    if (forceLogOut) {
      directDispatch(false, keyNames.forceLogOut);
      window.location.href = "/";
    }
  }, [forceLogOut, directDispatch]);

  return (
    <ThemeProvider theme={themes}>
      <Theme />
      <CustomToast />
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </ThemeProvider>
  );
};
export default Layout;
